/* ==========================================================================
   Woodbrass — Blog table of contents (sommaire)
   Génère un sommaire depuis les titres h2/h3 du corps d'article, le place en
   colonne gauche sticky (desktop) ou en bloc repliable (mobile), avec
   surlignage de la section courante au défilement (scroll-spy).
   Aucune modification du contenu des articles : tout est fait côté client.
   Chargé via sections/blog-nav.liquid (template.name == 'article').
   ========================================================================== */
(function () {
  'use strict';

  var MIN_HEADINGS = 3;               // en dessous, pas de sommaire

  // Le sommaire est construit côté client : son intitulé ne passe pas par `| t`.
  // Même repère que blog-products.js : la locale se lit sur <html lang>, on n'en
  // garde que la langue, et le français sert de secours.
  var TITRES = {
    fr: 'Sommaire', en: 'Contents', nl: 'Inhoud', es: 'Índice',
    pt: 'Índice', it: 'Indice', de: 'Inhalt'
  };
  var TITRE = TITRES[(document.documentElement.getAttribute('lang') || 'fr')
    .toLowerCase().split('-')[0]] || TITRES.fr;
  // Blocs spéciaux dont les titres ne doivent PAS entrer dans le sommaire
  var EXCLUDE = '.wb-faq, .wb-spec, .wb-callout, .wb-procon, ' +
                '.wb-product-card, .wb-comparison-table';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function slugify(text) {
    return (text || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')  // retire accents
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'section';
  }

  function collectHeadings(root) {
    var all = root.querySelectorAll('h2');            // sommaire = titres H2 uniquement
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var h = all[i];
      if (h.closest(EXCLUDE)) continue;                 // titre d'un bloc spécial
      var label = (h.textContent || '').trim();
      if (!label) continue;
      out.push({ el: h, level: 2, label: label });
    }
    return out;
  }

  function ensureIds(headings) {
    var used = {};
    headings.forEach(function (h) {
      var id = h.el.id;
      if (!id) {
        id = 'wb-' + slugify(h.label);
        var base = id, n = 2;
        while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
        h.el.id = id;
      }
      used[id] = true;
      h.id = id;
    });
  }

  function buildNav(headings) {
    var nav = document.createElement('nav');
    nav.className = 'wb-toc';
    nav.setAttribute('aria-label', TITRE);

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'wb-toc__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<span class="wb-toc__toggle-label">' + TITRE + '</span>' +
      '<svg class="wb-toc__chevron" width="18" height="18" viewBox="0 0 24 24" ' +
      'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
      'stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
    nav.appendChild(toggle);

    var ul = document.createElement('ul');
    ul.className = 'wb-toc__list';
    var links = {};
    headings.forEach(function (h) {
      var li = document.createElement('li');
      li.className = 'wb-toc__item wb-toc__item--h' + h.level;
      var a = document.createElement('a');
      a.className = 'wb-toc__link';
      a.href = '#' + h.id;
      a.textContent = h.label;
      li.appendChild(a);
      ul.appendChild(li);
      links[h.id] = a;
    });
    nav.appendChild(ul);
    return { nav: nav, toggle: toggle, links: links };
  }

  function wireToggle(nav, toggle) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function wireSmoothScroll(headings, links, nav, toggle) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    headings.forEach(function (h) {
      links[h.id].addEventListener('click', function (ev) {
        var target = document.getElementById(h.id);
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + h.id);
        // referme le sommaire replié (mobile)
        if (nav.classList.contains('is-open')) {
          nav.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  function wireScrollSpy(headings, links, ul) {
    var current = null;
    function setActive(id) {
      if (id === current) return;
      current = id;
      Object.keys(links).forEach(function (k) {
        var on = k === id;
        links[k].classList.toggle('is-active', on);
        if (on) links[k].setAttribute('aria-current', 'true');
        else links[k].removeAttribute('aria-current');
      });
      // garde le lien actif visible dans une liste qui déborde
      var link = links[id];
      if (link && ul.scrollHeight > ul.clientHeight) {
        var lt = link.offsetTop, lb = lt + link.offsetHeight;
        if (lt < ul.scrollTop || lb > ul.scrollTop + ul.clientHeight) {
          ul.scrollTop = lt - ul.clientHeight / 2;
        }
      }
    }
    // Ligne de déclenchement = juste sous l'en-tête sticky (offset CSS partagé).
    function line() {
      var v = parseInt(getComputedStyle(document.documentElement)
        .getPropertyValue('--wb-toc-top'), 10);
      return (isNaN(v) ? 160 : v) + 8;
    }
    var ticking = false;
    function update() {
      ticking = false;
      var y = line();
      // section courante = dernier titre dont le haut a franchi la ligne
      var activeId = headings[0].id;
      for (var i = 0; i < headings.length; i++) {
        if (headings[i].el.getBoundingClientRect().top - y <= 0) activeId = headings[i].id;
        else break;
      }
      // bas de page → dernière section (les derniers titres ne franchissent jamais la ligne)
      if (window.innerHeight + window.scrollY >=
          document.documentElement.scrollHeight - 4) {
        activeId = headings[headings.length - 1].id;
      }
      setActive(activeId);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  ready(function () {
    var content = document.querySelector('.article__content');
    if (!content) return;
    var wrapper = content.parentNode;                    // .article__wrapper
    var host = content.closest('.article--width');       // conteneur cadré du thème

    var headings = collectHeadings(content);
    if (headings.length < MIN_HEADINGS) return;          // sommaire inutile

    ensureIds(headings);
    var built = buildNav(headings);

    // Zone 2 colonnes [sommaire | contenu] : borne le sticky au contenu, pour que
    // le footer/partage (hors de cette zone) ne soient jamais recouverts.
    var layout = document.createElement('div');
    layout.className = 'wb-layout';
    wrapper.insertBefore(layout, content);               // prend la place du corps
    layout.appendChild(built.nav);                       // colonne gauche

    // 31/08/2026 — l'en-tête (H1) entre dans la grille, en ligne 1 de la colonne de
    // droite. Il restait sinon hors de la zone, donc centré sur la bande élargie de
    // 1188px alors que la prose commence à 308px : le titre paraissait décalé à gauche
    // de son propre contenu. Le mettre DANS la colonne rend l'alignement exact par
    // construction, sans reproduire les 260 + 48 en dur.
    var header = null;
    for (var c = 0; c < wrapper.children.length; c++) {
      if (wrapper.children[c].classList.contains('article__header')) {
        header = wrapper.children[c];
        break;
      }
    }
    if (header) layout.appendChild(header);              // colonne droite, ligne 1

    layout.appendChild(content);                         // colonne droite (déplace le corps)

    wrapper.classList.add('wb-has-toc');
    if (host) host.classList.add('wb-toc-host');         // élargit la bande (desktop)
    // Marqueur au niveau du document : les bandeaux auteur sont des SECTIONS distinctes,
    // hors de `host`, et doivent s'aligner sur la même bande que la prose.
    document.documentElement.classList.add('wb-toc-page');

    wireToggle(built.nav, built.toggle);
    wireSmoothScroll(headings, built.links, built.nav, built.toggle);
    wireScrollSpy(headings, built.links, built.nav.querySelector('.wb-toc__list'));
  });
})();
